import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {BaseResponse} from "../../core/BaseResponse";
import {URLS} from "../../core/URLS";
import {AuthEmailResponse} from "../../model/sso/AuthEmailResponse";
import {SessionManager} from "../../manager/SessionManager";
import {RefreshTokenResponse} from "../../model/sso/RefreshTokenResponse";


@Injectable()
export class SSOService {

  constructor(private httpClient: HttpClient,
              private sessionManger: SessionManager) {
  }

  registerEmail(name: string, email: string, phone: string, password: string) {
    return this.httpClient
      .post<BaseResponse<Boolean>>(URLS.REGISTER_EMAIL, {
        name: name,
        email: email,
        phone: phone,
        password: password
      })
  }

  registerEmailConfirm(email: string, confirmCode: number) {
    return this.httpClient
      .put<BaseResponse<Boolean>>(URLS.REGISTER_EMAIL_CONFIRM, {
        email: email,
        confirmCode: confirmCode
      })
  }

  authEmail(email: string, password: string) {
    return this.httpClient
      .post<BaseResponse<AuthEmailResponse>>(URLS.AUTH_EMAIL, {
        email: email,
        password: password
      })
  }

  resetEmail(email: string) {
    return this.httpClient
      .post<BaseResponse<Boolean>>(URLS.RESET_EMAIL, {
        email: email
      })
  }

  resetEmailConfirm(email: string, confirmCode: number, password: string, confirmNewPassword: string) {
    return this.httpClient
      .post<BaseResponse<Boolean>>(URLS.RESET_EMAIL_CONFIRM, {
        email: email,
        confirmCode: confirmCode,
        password: password,
        confirmNewPassword: confirmNewPassword
      })
  }

  refresh() {
    if (this.sessionManger.lastRefresh() != new Date().getMonth().toString() && this.sessionManger.isAuth()) {
      this.httpClient
        .post<BaseResponse<RefreshTokenResponse>>(URLS.REFRESH, {
          refreshToken: this.sessionManger.refreshToken(),
        }).subscribe(response => {
        this.sessionManger.setTokens(response.data.token, response.data.refreshToken)
      }, err => {
        this.sessionManger.clear()
      })
    }

  }


}
